import { isCustomCodeDashlet } from 'components/DashboardGrid/hooks/customCodeBlock';
import { isPluginContentDashlet } from 'components/DashboardGrid/hooks/usePluginContentBlock';
import { isStaticContentDashlet } from 'components/DashboardGrid/hooks/useStaticContentBlock';
import { isSessionAiBlock } from 'ts-components/AiBlockPanel/aiBlockSession';

type RenameDashlet = {
  id?: unknown;
  config?: Record<string, any>;
  [key: string]: unknown;
};

export const canRenameDashlet = (
  dashlet: RenameDashlet | null | undefined,
  sessionDashletId?: string | null
): boolean => !isSessionAiBlock(dashlet, sessionDashletId);

export const getDashletRenameAffordances = ({
  dashlet,
  builderContent,
  sessionDashletId,
}: {
  dashlet: RenameDashlet | null | undefined;
  builderContent?: unknown;
  sessionDashletId?: string | null;
}): { inlineTitle: boolean; menuRename: boolean } => {
  const renamable = canRenameDashlet(dashlet, sessionDashletId);
  const isPluginBlock = isPluginContentDashlet(dashlet);
  return {
    inlineTitle:
      renamable &&
      !builderContent &&
      !isPluginBlock &&
      !isCustomCodeDashlet(dashlet),
    menuRename: renamable && !isStaticContentDashlet(dashlet) && !isPluginBlock,
  };
};
